<template>
  <div class="container">
    <div class="main-head">
      <h3>讲师申请入驻</h3>
    </div>
    <div class="content" >
      <div class="main-body">
        <Form :label-position="labelTop">
          <FormItem label="讲师姓名">
            <Input :size="inputSize" v-model="addData.name" placeholder="姓名..."></Input>
          </FormItem>
          <FormItem label="手机号码">
            <Input :size="inputSize" v-model="addData.mobile" placeholder="手机号码..."></Input>
          </FormItem>
          <FormItem label="性别">
            <!-- <Select :size="inputSize" v-model="addData.sex" label-in-value>
              <Option value="1" key="1">男</Option>
              <Option value="2" key="2">女</Option>
            </Select>-->
            <RadioGroup v-model="addData.sex">
              <Radio value="1" label="1">男</Radio>
              <Radio value="2" label="2">女</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="学历">
            <Select :size="inputSize" v-model="addData.education" label-in-value>
              <Option value="1" key="1">小学</Option>
              <Option value="2" key="2">初中</Option>
              <Option value="3" key="3">高中</Option>
              <Option value="4" key="4">中专</Option>
              <Option value="5" key="5">大专</Option>
              <Option value="6" key="6">本科</Option>
              <Option value="7" key="7">硕士</Option>
              <Option value="8" key="8">其他</Option>
            </Select>
          </FormItem>
          <!-- <FormItem label="电子邮箱">
                <Input :size="inputSize" v-model="addData.email" placeholder="邮箱..."></Input>
          </FormItem>-->
          <FormItem label="身份证号码">
            <Input :size="inputSize" v-model="addData.idCard" placeholder="身份证号码..."></Input>
          </FormItem>
          <FormItem label="联系地址">
            <Input :size="inputSize" v-model="addData.address" placeholder="请输入联系地址..."></Input>
          </FormItem>
          <FormItem label="新媒体账号">
            <Input :autosize="true" type="textarea" :size="inputSize" v-model="addData.newAccount" placeholder="请输入您的微博、微信、抖音、头条等新媒体账号"></Input>
          </FormItem>
          <FormItem label="个人介绍">
            <Input
              v-model="addData.introduce"
              type="textarea"
              :autosize="{minRows: 2,maxRows: 5}"
              placeholder="个人介绍..."
            ></Input>
          </FormItem>
          <!-- <FormItem label="授课经验">
            <Input
              v-model="addData.haveEx"
              type="textarea"
              :autosize="{minRows: 2,maxRows: 5}"
              placeholder="授课经验..."
            ></Input>
          </FormItem>-->
          <FormItem label="主讲课程">
            <Input
              v-model="addData.courses"
              type="textarea"
              :autosize="{minRows: 2,maxRows: 5}"
              placeholder="主讲课程..."
            ></Input>
          </FormItem>
          <!-- <FormItem label="备注">
            <Input
              v-model="addData.remark"
              type="textarea"
              :autosize="{minRows: 2,maxRows: 5}"
              placeholder="备注..."
            ></Input>
          </FormItem>-->
          <!-- <FormItem label="身份证正面">
            <div class="upload-image">
              <span v-if="rand<0">{{rand}}</span>
              <div
                class="demo-upload-list"
                style="text-align: left;"
                v-if="addData.idCardImgPShow&&addData.idCardImgPShow!=''"
              >
                <template>
                  <img :src="addData.idCardImgPShow" />
                  <div class="demo-upload-list-cover" v-show="false">
                    <Icon type="ios-eye-outline" @click.native="handleView(addData.idCardImgPShow)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="addData.idCardImgPShow='',addData.idCardImgP='',rand++"></Icon>
                  </div>
                </template>
              </div>
              <Upload
                ref="upload"
                :show-upload-list="false"
                :on-success="handleSuccess3"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                multiple
                type="drag"
                :headers="{'Authorization':'bearer'+token}"
                :action="httpUrl+'/udload/upload/file'"
                style="display: inline-block; width: 58px;"
              >
                <div style="width: 58px;height:58px;line-height: 58px;">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload>
            </div>
          </FormItem>-->
          <!-- <FormItem label="身份证反面">
            <div class="upload-image">
              <div
                class="demo-upload-list"
                style="display: inline-block"
                v-if="addData.idCardImgSShow&&addData.idCardImgSShow!=''"
              >
                <template>
                  <img :src="addData.idCardImgSShow" />
                  <div class="demo-upload-list-cover" v-show="false">
                    <Icon type="ios-eye-outline" @click.native="handleView(addData.idCardImgSShow)"></Icon>
                    <Icon
                      type="ios-trash-outline"
                      @click.native="addData.idCardImgSShow='',addData.idCardImgS='',rand++"
                    ></Icon>
                  </div>
                </template>
              </div>
              <Upload
                ref="upload"
                :show-upload-list="false"
                :on-success="handleSuccess4"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                multiple
                type="drag"
                :headers="{'Authorization':'bearer'+token}"
                :action="httpUrl+'/udload/upload/file'"
                style="display: inline-block;width:58px;"
              >
                <div style="width: 58px;height:58px;line-height: 58px;margin:0">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload>
            </div>
          </FormItem>-->
          <!-- <FormItem label="证书">
            <div class="upload-image">
              <div
                class="demo-upload-list"
                style="display: inline-block"
                v-for="(item,index) in addData.certificateUrl"
              >
                <template>
                  <img :src="item.urlShow" />
                  <div class="demo-upload-list-cover" v-show="false">
                    <Icon type="ios-eye-outline" @click.native="handleView(item.urlShow)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="clears(index)"></Icon>
                  </div>
                </template>
              </div>
              <Upload
                ref="upload"
                :show-upload-list="false"
                :on-success="handleSuccess2"
                :before-upload="handleBeforeUpload"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :on-exceeded-size="handleMaxSize"
                multiple
                type="drag"
                :headers="{'Authorization':'bearer'+token}"
                :action="httpUrl+'/udload/upload/file'"
                style="display: inline-block;width:58px;"
              >
                <div style="width: 58px;height:58px;line-height: 58px;margin:0">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload>
            </div>
          </FormItem>-->
          <FormItem style="text-align: center;">
            <Button
              :primary="true"
              size="large"
              style="width: 100%;margin: 10px auto 60px;background-color: #45b035;color: #fff;"
              @click="add"
            >提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>

    <cp-footer></cp-footer>
  </div>
</template>

<script>
import { addLecturer } from "@/api/api";
import cpFooter from "@/views/footer";
import { mapGetters } from 'vuex';

export default {
  name: "us",
  components: {
    cpFooter
  },
  data() {
    return {
      eye: {
        open: true,
        reverse: false
      },
      inputSize: "large",
      labelTop: 'top',
      rand: 0,
      addData: {
        sex: "1",
      },
      placeholder: "请输入账号",
      autofocus: true,
      autocomplete: true,
      token: ""
    };
  },
  computed: {
    ...mapGetters(['httpUrl'])
  },
  created() {

  },
  methods: {
    getUrlName(url) {
      url = decodeURIComponent(url);
      let name = "";
      if (url && url != "") {
        let list = url.split("?");
        let nameList = list[0].split("/");
        name = nameList[nameList.length - 1];
      }
      return name;
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "上传失败",
        desc: "图片大小不能超过2M"
      });
    },
    handleBeforeUpload() {
      if (this.addData.certificateUrl) {
        const check = this.addData.certificateUrl.length < 8;
        if (!check) {
          this.$Notice.warning({
            title: "图片不能多于8张"
          });
        }
        return check;
      } else return true;
    },
    handleView(url) {
      this.imgName = url;
      this.visible = true;
    },
    handleRemove(res, file) {
      if (this.addData.coursewareUrl && this.addData.coursewareUrl.length > 0) {
        for (let i = 0; i < this.addData.coursewareUrl.length; i++)
          if (this.addData.coursewareUrl[i].url == res.response.data) {
            this.addData.coursewareUrl.splice(i, 1);
          }
      }
    },
    show() {
      this.addData = {
        id: 0,
        coursewareUrl: [],
        certificateUrl: []
      };
    },
    handleSuccess1(res, file) {
      // 因为上传过程为实例，这里模拟添加 url
      file.url = this.httpUrl + "/udload/upload/file";
      file.name = "file";
      this.addData.photo = res.data.pathUrl;
      this.addData.photoShow = res.data.fullUrl;
      this.rand++;
    },
    handleSuccess2(res, file) {
      file.url = this.httpUrl + "/udload/upload/file";
      file.name = "file";
      if (!this.addData.certificateUrl) {
        this.addData.certificateUrl = [];
      }
      this.addData.certificateUrl.push({
        id: this.addid,
        url: res.data.pathUrl,
        urlShow: res.data.fullUrl
      });
      this.addid--;
      this.rand++;
      console.log(this.addData.certificateUrl);
    },
    handleSuccess3(res, file) {
      console.log(res);
      // 因为上传过程为实例，这里模拟添加 url
      file.url = this.httpUrl + "/udload/upload/file";
      file.name = "file";
      this.addData.idCardImgP = res.data.pathUrl;
      this.addData.idCardImgPShow = res.data.fullUrl;
      this.rand++;
    },
    handleSuccess4(res, file) {
      console.log(res);
      // 因为上传过程为实例，这里模拟添加 url
      file.url = this.httpUrl + "/udload/upload/file";
      file.name = "file";
      this.addData.idCardImgS = res.data.pathUrl;
      this.addData.idCardImgSShow = res.data.fullUrl;
      this.rand++;
    },

    handleSuccess5(res, file) {
      console.log(res);
      // 因为上传过程为实例，这里模拟添加 url
      file.url = this.httpUrl + "/udload/upload/file";
      file.name = "file";
      if (!this.addData.coursewareUrl) {
        this.addData.coursewareUrl = [];
      }
      this.addData.coursewareUrl.push({
        id: this.addid,
        url: res.data.pathUrl,
        urlShow: res.data.fullUrl
      });
      this.addid--;
    },
    showTab(msg) {
      this.$Message.error(msg);
    },
    //上级机构
    //添加
    add() {
      let data = this.addData;
      if (!data.name || data.name == "") {
        this.showToastTime("请输入讲师姓名");
      } else if (!data.mobile || data.mobile == "") {
        this.showToastTime("请输入手机号码");
      } else if (!data.sex || data.sex == "") {
        this.showToastTime("请选择性别");
      } else if (!data.education || data.education == "") {
        this.showToastTime("请选择学历");
      }
      // else if (!data.email || data.email == "") {
      //   this.showTab("请输入邮箱地址");
      // }
      else if (!data.idCard || data.idCard == "") {
        this.showToastTime("请输入身份证号码");
      } else if (!data.courses || data.courses == "") {
        this.showToastTime("请输入主讲课程");
      }
      // else if (!data.haveEx || data.haveEx == "") {
      //   this.showTab("请输入授课经验");
      // }
      else if (!data.address || data.address == "") {
        this.showToastTime("请输入联系地址");
      } else if (!data.introduce || data.introduce == "") {
        this.showToastTime("请输入个人介绍");
      } else {
        if (data.coursewareUrl && data.coursewareUrl.length > 0) {
          data.coursewareUrl.forEach(o => {
            o.url = o.url;
          });
        }
        // console.log("data", data);
        data.status = 1;
        const toast = this.$createToast({
          txt: '申请中......',
          type: 'loading',//显示图标或文本类型  //correct 图标 //txt 文字
          time: 800, //show时间
          onTimeout: () => {
            addLecturer(data).then(res => {
              const toast1 = this.$createToast({
                txt: '申请成功,请耐心等待我们的审核',
                type: 'correct',//显示图标或文本类型  //correct 图标 //txt 文字
                time: 800, //show时间
              })
              toast1.show();
              this.addData = {
                sex: "1",
              };
              this.addid = 0;
            })
            .catch(function(reason) {
              alert(reason);
            });
          }
        });
        toast.show();
      }
    },
    // 滴滴弹出 1s
    showToastTime(msg,type='txt',time=800) {
      const toast = this.$createToast({
        txt: msg,
        type: type,//显示图标或文本类型  //correct 图标 //txt 文字
        time: time //show时间
      })
      toast.show();
    },
    clear(index) {
      this.addData.coursewareUrl.splice(index, 1);
    },
    clears(index) {
      this.addData.certificateUrl.splice(index, 1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/css/rem.scss";
// 表单上下布局
.ivu-radio-group {
  width: 100%;
}
.ivu-form-item {
  margin-bottom: 12px;
}
.demo-upload-list {
  //图片上传
  display: inline-block;
  text-align: left;
  width: 58px;
  height: 58px;
  > img {
    height: 100%;
    width: 100%;
  }
}
.upload-image {
  text-align: left;
  width: 100%;
  display: inline-block;
  width: 100%;
  position: relative;
  vertical-align: middle;
  line-height: normal;
}
.content {
  max-width: 700px;
  margin: 0 auto;
  min-width: 100px;
  padding: 0 24px;
}
.main-head {
  height: rem(120);
  line-height: rem(120);
  background-color: #45b035;
  h3 {
    font-size: 21px;
    color: #fff;
    text-align: center;
  }
}
.main-body {
  padding-top: 24px;
}
.container {
  // position: absolute;
  // left: 0;
  // top: 0;
  -webkit-overflow-scrolling : touch;
  background-color: #fff;
  width: 100%;
  text-align: left;
}
/* 字体样式 */
// /deep/ .ivu-form .ivu-form-item-label {
//   color: #fff;
// }

.logo {
  width: 25%;
  margin-left: 20px;
  line-height: 3rem;
}
.logo img {
  width: 100%;
  vertical-align: middle;
}
h1 {
  font-size: 1.3rem;
  color: white;
}
h2 {
  font-size: 1rem;
  color: #f1e9e9;
  margin-top: 1rem;
}
.content-input {
  margin-top: 2.5rem;
}
.text span {
  font-size: 0.8rem;
  color: white;
}
// .main-foot {
//   padding-bottom: 30px;
//   width: 100%;
//   text-align: center;
//   font-size: 0.8rem;
//   bottom: 10px;
//   color: #333;
// }
</style>



// WEBPACK FOOTER //
// src/components/us.vue